export default "__VITE_ASSET__C764MdzE__"